import '../../App.css';
import React from 'react';
import Cards from '../Cards';

function Projects() {
    return (
        <> 
            <h1>Projects + Experience <i class="fa-solid fa-feather"></i></h1>
            <Cards/>
        </>
    )
}

export default Projects;